import { toast } from "sonner";
import { useLanguage } from "@/lib/i18n/LanguageContext";
import { useStartPaymentMethodSetup } from "./hooks";
import { billingErrorMessage } from "./messages";

export const PAYMENT_SETUP_RETURN_PATH = "/billing/details";

/**
 * Send the browser to Stripe Checkout to attach a card or a SEPA mandate.
 *
 * A full page navigation, not a popup: Checkout's hosted page owns the whole
 * flow including any 3-D Secure step, and comes back to
 * `PAYMENT_SETUP_RETURN_PATH` with its own query parameters, which
 * `BillingDetailsPage` reads on arrival.
 */
export function useStartSetup(orgId: string) {
  const { t, language } = useLanguage();
  const mutation = useStartPaymentMethodSetup();
  const start = async () => {
    try {
      const url = await mutation.mutateAsync({
        orgId,
        returnUrl: `${window.location.origin}${PAYMENT_SETUP_RETURN_PATH}`,
        // Checkout is shown in the language the app is being shown in. The
        // parameter is Stripe's `locale` enum, which covers both `en` and `et`
        // (docs.stripe.com/api/checkout/sessions/create); the function drops
        // anything Checkout does not speak and lets it fall back to `auto`.
        locale: language,
      });
      window.location.assign(url);
    } catch (error) {
      toast.error(billingErrorMessage(error, t, t.billing.details.setupFailed));
    }
  };
  return { start, isPending: mutation.isPending };
}
